import { SET_DIALOG } from "../actions/types";

const initialState = {
    isOpen: false,
    title: 'Oops! Internal Server Error',
    message1: 'Sorry, something went wrong on our end.',
    message2: 'Please contact your administrator' 
};

const DialogReducer = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case SET_DIALOG:
            return { ...state, isOpen: payload.isOpen, title: payload.title, message1: payload.message1, message2: payload.message2, subTitle: payload.subTitle };

        default:
            return state;
    }
};

export default DialogReducer;